module.exports = __webpack_public_path__ + "static/media/priceUpArrowWeb.85676788.svg";